module.exports = __webpack_public_path__ + "img/userList.af8a3775.png";